import { AutoFormat } from 'roosterjs-editor-plugins/lib/AutoFormat';
import { ContentEdit } from 'roosterjs-editor-plugins/lib/ContentEdit';
import { CustomReplace as CustomReplacePlugin } from 'roosterjs-editor-plugins/lib/CustomReplace';
import { CutPasteListChain } from 'roosterjs-editor-plugins/lib/CutPasteListChain';
import { ImageEdit } from 'roosterjs-editor-plugins/lib/ImageEdit';
import { Paste } from 'roosterjs-editor-plugins/lib/Paste';
import { TableCellSelection } from 'roosterjs-editor-plugins/lib/TableCellSelection';
import { TableResize } from 'roosterjs-editor-plugins/lib/TableResize';
import {
    createContextMenuPlugin,
    createImageEditMenuProvider,
    createListEditMenuProvider,
} from 'roosterjs-react/lib/contextMenu';

export default function getToggleablePlugins() {
    const imageEdit = new ImageEdit({
            preserveRatio: true,
        });

    const plugins  = {
        contentEdit: new ContentEdit(true),
        paste: new Paste(),
        imageEdit,
        cutPasteListChain: new CutPasteListChain(),
        customReplace: new CustomReplacePlugin(),
        autoFormat: new AutoFormat(),
        listEditMenu:  createListEditMenuProvider(),
        imageEditMenu:  createImageEditMenuProvider(imageEdit),
        contextMenu: createContextMenuPlugin(),
    };

    return Object.values(plugins);
}